exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "img.not-so-big[data-v-daa53c18]{max-height:70vh!important}.logos[data-v-daa53c18]{width:80%;margin:auto}.logos img[data-v-daa53c18]{padding:20px;background:transparent;border:none;box-shadow:none}.timer[data-v-daa53c18]{padding-top:15px;padding-left:15px;width:10%}.logo[data-v-daa53c18]{display:inline;max-width:30%;background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-daa53c18","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 20
// module chunks = 0